import { Box, Button, Grid, Typography } from '@material-ui/core'
import { UploadMultiFile } from 'src/components/upload'

/** Blocks form edits in preview; elements with data-preview-allow stay clickable (notes, attachments, formula). */
export const ESTIMATE_PREVIEW_LOCK_SX = {
  userSelect: 'none',
  '& input, & textarea': {
    pointerEvents: 'none',
  },
  '& .MuiInputBase-root': {
    pointerEvents: 'none',
  },
  '& .MuiAutocomplete-root, & .MuiSwitch-root, & .MuiCheckbox-root, & .MuiFormControlLabel-root': {
    pointerEvents: 'none',
  },
  '& .MuiSvgIcon-root': {
    pointerEvents: 'none',
  },
  '& .MuiIconButton-root:not([data-preview-allow])': {
    pointerEvents: 'none',
  },
  '& .MuiButton-root:not([data-preview-allow])': {
    pointerEvents: 'none',
  },
  '& [data-preview-allow]': {
    pointerEvents: 'auto',
  },
  '& [data-preview-allow] .MuiSvgIcon-root': {
    pointerEvents: 'none',
  },
}

export const getEstimatePreviewUploadProps = (isPreview) =>
  isPreview
    ? { disabled: true, onDrop: undefined, onRemove: undefined, onRemoveAll: undefined }
    : {}

export const getEstimatePreviewFormulaModalProps = (isPreview) =>
  isPreview ? { hideEdit: true, hidePrintAndEmail: true } : {}

export const getEstimatePreviewNoteFieldProps = (isPreview) =>
  isPreview ? { disabled: true, onChange: undefined } : {}

export function renderPreviewAttachmentContent(linkedAttachments) {
  return (
    <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          View Attachments
        </Typography>
        {(linkedAttachments || []).length > 0 ? (
          <UploadMultiFile
            showPreview
            allowDownload
            disabled
            multiple
            files={linkedAttachments}
          />
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
            No attachments
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

/** In preview show Close only; otherwise render the normal Save/Clear actions. */
export function EstimatePreviewNoteActions({ isPreview, onClose, children }) {
  if (!isPreview) return children

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={12} md={4}>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
